import React from 'react';
import request from 'utils/request_ajax';

class DataOverview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      /** @todo 'error' is set in state but we're not actually handling it */
      // eslint-disable-next-line react/no-unused-state
      error: false,
    };
    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    if (this.props.dataRoute) {
      request
        .get(this.props.dataRoute)
        .then(data => this.setState({ data }))
        /** @todo 'error' is set in state but we're not actually handling it */
        // eslint-disable-next-line react/no-unused-state
        .fail(() => this.setState({ error: true }));
    }
  }

  render() {
    const { data } = this.state;
    const { imgSrc, imgDescription, dataRoute } = this.props;

    return (
      <div className="DataCard-dataOverview">
        <img src={imgSrc} alt={imgDescription} title={imgDescription} />
        {dataRoute && data && data.count.toLocaleString()}
        {dataRoute && !data && '…'}
      </div>
    );
  }
}

export default DataOverview;
